<template>
    <div>
        <modal-x :show="showMenu" @onclose="setShow(false)" :content-style="{maxWidth:'800px'}">
            <filter-menu-form :filter-info="filterInfo" @onclose="setShow(false)"  :listing-type="listingType" :shop-code="shopCode"></filter-menu-form>
        </modal-x>
    </div>
</template>

<script>
    import modalX from '../components/base/ModalX2.vue';
    import FilterMenuForm from './FilterMenuForm.vue';

    export default {
        components: {
            modalX: modalX,
            FilterMenuForm
        },
        props: ["filterInfo", "shopCode","listingType"],
        computed: {

        },
        data: function () {
            return {
                showMenu: true
            }
        },
        methods: {
            setShow: function (toShow) {
                this.showMenu = toShow;
                if (this.showMenu === false) {
                    this.$emit("onclose");
                }
            }
        },
        created: function () {
            
        }
    }
</script>
